import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <React.Fragment>
      <section className="inner-intro bg-1 bg-overlay-black-70">
        <div className="container">
          <div className="row text-center intro-title">
            <div className="col-md-12 text-md-start d-inline-block">
              <div className="section-title">
                <h2 className="text-center" style={{color: 'white'}}>Error 404</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="error-page page-section-ptb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="error-content text-center">
                <h2>404</h2>
                <img className="img-fluid center-block" src="images/car/23.png" alt="" />
                <h3 className="text-red">Oops</h3>
                <strong className="text-black">The Page you were looking for, couldn't be found.</strong>
                <p>Can't find what you looking for? Take a moment and start from our <Link to="/">Home Page</Link>.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <div className="car-top">
        <span><img src="images/car.png" alt="" /></span>
      </div>
    </React.Fragment>
  );
}

export default NotFound;
